import { SelectedFilters } from '../../types/filters.type';
import useStreetviewFilterNavigation from '../../hooks/useNavigateUpdateFilters';

type DescriptionProps = {
    description: string;
    descriptionFilters: SelectedFilters | null;
};

const descriptionDelimiter = '**';

export default function Description({ description, descriptionFilters }: DescriptionProps) {
  const updateFiltersAndRedirect = useStreetviewFilterNavigation();

  const adaptDescription = (descriptionString: string, delimiter: string) => {
    let stringArray: string[];
    if (descriptionString.includes(delimiter)) {
    // detect bold text markers and split string accordingly
      stringArray = descriptionString.split(/(\*\*[^*]+\*\*)/g).filter((str) => str !== '');
    } else {
      stringArray = [descriptionString];
    }
    return stringArray;
  };

  const renderDescription = (descriptionString: string, filters: SelectedFilters | null) => {
    const adaptedString = adaptDescription(descriptionString, descriptionDelimiter);
    return (
      <div className="leading-none font-thin text-xs">
        {adaptedString.map((str) => {
          if (str.startsWith(descriptionDelimiter) && str.endsWith(descriptionDelimiter) && filters) {
            return (
              <button
                type="button"
                key={str}
                onClick={() => updateFiltersAndRedirect(filters)}
                className="underline hover:font-bold text-primary cursor-pointer p-0"
              >
                {str.replace(/\*\*/g, '')}
              </button>
            );
          }
          return <span className="text-piptext-body" key={str}>{str}</span>;
        })}
      </div>
    );
  };

  return (
    description.length > 0 ? renderDescription(description, descriptionFilters) : null
  );
}
